
export class UDate {
  // 构造函数
  constructor () {
    // 实例化当前日期
    this.current = new Date()
    this.year = this.current.getFullYear()
    this.month = this.current.getMonth()
    this.date = this.current.getDate()
    this.day = this.current.getDay()
  }

  // 获取某月份的天数
  // @params { Object }  year month ...
  getDate (params) {
    const { year, month } = params
    const date = new Date(year || this.year, (month || this.month) + 1, 0)
    return date.getDate()
  }

  // 获取某一天是星期几
  // @params { Object }  year month  ||  new Date();
  getDay (params) {
    const { year, month, date } = params
    const Dates = year ? new Date(year, month, date) : params
    return Dates.getDay()
  }
}

export default new UDate()
